import enMessages from '../json/ko_KR.json';

const KoLang = {
    messages: {
        ...enMessages,
    },
    locale: 'ko-KR',
};
export default KoLang;
